import { combineReducers } from "redux";
import { marsReducer } from "./marsReducer";

export default combineReducers({
  marsReducer
});
